import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import API from '../endpoints';

export const useConfirmNewsletterMutation = () => {
  return useMutation({
    mutationFn: confirmNewsletter,
  });
};

const confirmNewsletter = async (token: string) => {
  const { data } = await axios.post<any[]>(API.endpoints.newsletterConfirm, { token });
  return data;
};
